import { applicationService } from 'services/application';

export function resolveFromToken(key: string): string | null {
  const token = applicationService.getToken();
  if (!token) {
    return null;
  }
  try {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    return decodedToken[key];
  } catch (e) {
    return null;
  }
}
